import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './allowed-countries-modal.magic.css.js';
import script from './allowed-countries-modal.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"data-v-test-id":"allowed-countries-modal"}},[_c('magic-ui-text',{staticClass:"content",attrs:{"part":"content","data-v-test-id":"allowed-countries-modal-content","content":_vm.$t('allowed-countries-modal.content')}}),_vm._v(" "),_c('magic-ui-button',{staticClass:"button action",attrs:{"wide":"","variant":"primary","part":"button action","data-v-test-id":"allowed-countries-modal-exit-button"},domProps:{"innerHTML":_vm._s(_vm.$t('allowed-countries-modal.exit'))},on:{"click":function($event){return _vm.exit()}}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-458c88d1_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-458c88d1";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
